import type { SupportedLocaleType } from '@pushflow/constants'
import type { i18n as I18nInstance } from 'i18next'
import { useEffect, useState } from 'react'
import { initI18n, loadLocalizationResources } from '../i18n/utils'

export const useAppI18n = (lang: SupportedLocaleType) => {
  const [instance, setInstance] = useState<I18nInstance>()

  useEffect(() => {
    let mounted = true
    initI18n(lang)
      .then((inst) => {
        if (mounted) {
          setInstance(inst)
        }
      })
      .catch(() => initI18n('en').then((inst) => mounted && setInstance(inst)))
    return () => {
      mounted = false
    }
  }, [])

  useEffect(() => {
    if (lang && instance) {
      void loadLocalizationResources(lang).then((locale) => {
        void instance
          .addResourceBundle(lang, 'translation', locale, true, true)
          .changeLanguage(lang)
      })
    }
  }, [lang, instance])

  return instance
}
